import { ReactRenderer } from '@philips-internal/oswald-ui-engine';
import { createPreviewSelectable } from '../../components/selectable/preview-selectable.js';
import { isNodeTypeValid } from '../../utils/is-node-valid.js';
/**
 * Renderer to be used when running applications in their preview mode.
 *
 * Each node rendered will be wrapped with the {@link createPreviewSelectable|PreviewSelectable} component,
 * which adds context menu functionalities to the node, allowing communication with Oswald's editor running in parallel.
 */
class PreviewRenderer extends ReactRenderer {
    getComponentByType(node) {
        const cachedComponent = this.cache.get(node.type);
        if (cachedComponent) {
            return cachedComponent;
        }
        if (!isNodeTypeValid(node.type)) {
            throw new Error(`[PreviewRenderer]: Invalid node type: ${node.type}`);
        }
        const wrappedComponent = createPreviewSelectable({
            component: super.getComponentByType(node),
            node,
            propTypes: super.getComponentMetadataByType(node).getPropTypes(),
        });
        this.cache.set(node.type, wrappedComponent);
        return wrappedComponent;
    }
}
export { PreviewRenderer, };
//# sourceMappingURL=preview-renderer.js.map